import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useResumeCardContext from "../ResumeCardContext";
import Button from "src/components/Button";
import useAuth from "src/hooks/selectors/useAuth";
import useBackUrl from "src/hooks/useBackUrl";

interface ResumeBioProps extends Translation {
	editable?: boolean;
}

function ResumeBio({ t, editable }: ResumeBioProps) {
	const auth = useAuth();
	const { resume } = useResumeCardContext();
	const backUrl = useBackUrl();

	if (!resume.bio && resume.id === auth.id && editable) {
		return (
			<div
				className={`flex flex-col text-center ${!editable && "gap-4"}`}
			>
				<h3>{t("title-empty")}</h3>
				<div className="flex flex-1 justify-center mt-4">
					<Button
						type="dark"
						xsmall
						className="w-52"
						to={`/profile/resume/create/general?${backUrl}`}
					>
						<i className="fas fa-plus mr-2"></i>
						{t("add")}
					</Button>
				</div>
			</div>
		);
	}

	if (!resume.bio) {
		return <></>;
	}

	return (
		<div className={`flex flex-col ${!editable && "gap-4"}`}>
			{editable ? (
				<div className="flex justify-between">
					<h3>{t("title")}</h3>
					<Button
						type="none"
						iconOnly={true}
						icon="fa fa-pencil"
						to={`/profile/resume/create/general?${backUrl}`}
					/>
				</div>
			) : (
				<>
					<h3>{t("title")}</h3>
				</>
			)}
			{resume.bio.bio}
		</div>
	);
}

ResumeBio.locale = {
	nl: {
		title: "Over mij",
		"title-empty": "Je hebt nog geen bio",
		add: "Toevoegen",
	},
	en: {
		title: "About me",
		"title-empty": "You don't have a bio yet",
		add: "Add",
	},
};

export default withTranslation(ResumeBio);
